exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "app-version{display:inline-flex;justify-content:center;align-items:center;white-space:nowrap}app-version>span{line-height:1em;font-size:12px;font-weight:400;color:inherit;padding:4px 8px;border-radius:20px;border:2px solid currentColor}", ""]);

